export default "__VITE_ASSET__BaosdkZn__"